export enum AuthState {
  LOGGED_IN,
  LOGGED_OUT,
}
